import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import ComponentContainer from 'containers/ComponentContainer';

export default class FormContainer extends Component {
    static propTypes = {
        onSubmit: PropTypes.func.isRequired
    };

    render() {
        const { initialValues, validationSchema, loading } = this.props;

        return (
            <ComponentContainer loading={loading}>
                {parentProps => {
                    return (
                        <Formik
                            initialValues={initialValues}
                            enableReinitialize={true}
                            validationSchema={validationSchema}
                            onSubmit={this.handleSubmit}
                        >
                            {props => {

                                this.mergedProps = {
                                    ...parentProps,
                                    ...props,
                                    ...this.props,
                                };

                                let { handleSubmit } = props;

                                return (
                                    <form onSubmit={handleSubmit}>
                                        {typeof (this.props.children) === 'function' ? this.props.children(this.mergedProps) : this.props.children}
                                    </form>
                                )
                            }}
                        </Formik>
                    );
                }}
            </ComponentContainer>
        );
    }

    handleSubmit = (values) => {
        const { onSubmit } = this.props;

        onSubmit(values, this.mergedProps);
    };
}